import { axios } from "./axios";

export const system = {
  // 获取机构列表
  getDeptList: (params?: any) => {
    return axios({
      url: "/system/api/sys/branch/public-combo-root",
      method: "get",
      params,
    });
  },
  // 自动登录
  autoLogin: (params?: any) => {
    return axios({
      url: "/system/api/metabase/public-login",
      method: "post",
      data: params,
    });
  },
};
